import { BaseBus } from './BaseBus';
import { CommonFunctions } from '../static/common-functions';
import { DispatchRefTrackingBus } from './DispatchRefTrackingBus';

export class AdditionalDispatchQVData extends BaseBus
{
    constructor(data: AdditionalDispatchQVData = null) {
        super(data);
        if (!data) {
            this.clear();
        }
        else {

            let arrRefTrk = [];
            if (CommonFunctions.hasArrayValue(data.refTracking)) {
                for (let i = 0; i < data.refTracking.length; i++) {
                    let refTrkData = new DispatchRefTrackingBus(data.refTracking[i]);
                    arrRefTrk.push(refTrkData);
                }
                this.refTracking = arrRefTrk;
            }
        }
    }
    clear() {
        this.callbackNumber = "";
        this.callbackPerson = "";
        this.estimatedInvoiceAmount = 0;
        this.refTracking = null;
    }
    getRefTrackingStatus(): number { //0-No Recrods, 1-Has Records no complete, 2-Complete
        let status: number = 0;
        if (CommonFunctions.hasArrayElementValue(this.refTracking)) {
            status = 1;
            let compl = this.refTracking.filter(s => s.isComplete == true);
            if (CommonFunctions.hasArrayElementValue(compl)) {
                status = 2;
            }
        }
        return status;
    }
    refTracking: DispatchRefTrackingBus[];
    callbackPerson: string;
    callbackNumber: string;
    estimatedInvoiceAmount: number;
    fieldInvoiceQueueId: string;
}
